/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import productFlowService from './../../../../services/productFlow';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
    };
  },

  computed: {
    ...mapGetters({
      productFlows: 'paginateproductFlows',
    }),

    productFlowsList() {
      return this.productFlows.items.map((b) => {
       /* let cardClass = '';

        if (b.billStatus === 'Overdue') {
          cardClass = 'card-red';
        } else if (b.billStatus === 'Cleared') {
          cardClass = 'card-green';
        } else if (b.billStatus === 'Sent') {
          cardClass = 'card-yellow';
        }

        Object.assign(b, {
          number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
          value: `${b.totalValue.toFixed(2)} NOK`,
          amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
          dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
          cardClass,
        });*/

        return b;
      });
    },
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 50);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/pagination/pagination.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mixins: [
    SearchMixin,
  ],

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('static.inventory.title'),
        options: [
          {
            title: this.$t('static.inventory.products.view'),
            route: {
              name: 'products.index',
            },
          },
          {
            title: this.$t('static.inventory.products.create'),
            route: {
              name: 'products.create',
            },
          },
        ],

      },
      {
        title: this.$t('static.productGroups.filters.title'),
        options: [
          {
            title: this.$t('static.productGroups.filters.latest'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'latest',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.pastMonth'),
            route: {
              name: 'productGroups.index',
              query: {
                filter: 'pastMonth',
              },
            },
          },
          {
            title: this.$t('static.productGroups.filters.all'),
            route: {
              name: 'productGroups.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.productGroups.create.title')}`,
          route: {
            name: 'productGroups.create',
          },
        },
      },

      {
        title: this.$t('static.productFlow.title'),
        options: [
          {
            title: this.$t('static.productFlow.filters.all'),
            route: {
              name: 'productFlow.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.productFlow.create.title')}`,
          route: {
            name: 'productFlow.create',
          },
        },
      },
    ]);
    this.all(1, 50);
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    /**
     * Fetches paginated productFlow.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all : debounce( function(page, limit) {
        this.loading = true;
        productFlowService.items({
          page,
          limit,
          search: this.getSearch(),
          filter: this.$route.query.filter,
        }).then(() => {
          this.loading = false;
        }).catch(() => {
         // this.loadProductsing = false;
         this.loading = false;
        });
    },800),

    /**
     * Go to edit view for productFlow.
     *
     * @param  {Object} productFlow The productFlow object.
     */
    editproductFlow(productFlow) {
      const name = 'productFlow.edit';
      this.$router.push({
        name,
        params: { id: productFlow.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productFlow/index/index.js